import { SearchShieldFilled, DocumentBulletListRegular } from "@fluentui/react-icons";
import { useTabStore } from "../../../providers/TabProvider";
import { rootUseStyles } from "../../../taskpane/fluent-style";
import { Button, Spinner } from "@fluentui/react-components";
import React from 'react'
import { useMutation } from "@tanstack/react-query";
import { useResultStore } from "../../../providers/ResultProvider";
import { runDeepScan } from "../../../api";
import { FinderResultType } from "../../../types";



export default function RunningDeepScanButton({ isCheckingDeepScan }: { isCheckingDeepScan?: boolean }) {
    const setActiveTab = useTabStore((s) => s.setActiveTab);
    const setDeepScanData = useResultStore((s) => s.setDeepScanData);
    const deepScanData = useResultStore((s) => s.deepScanData);
    const insightData = useResultStore((s) => s.insightData);
    const emailData = useTabStore((s) => s.emailData);
    const { mutate, isPending, error, isError } = useMutation({
        mutationFn: async (data: FinderResultType) => {
            return await runDeepScan({ data, emailData });
        },
        onSuccess: (data) => {
            console.log(data, "Data from API - inside onSuccess");

            // Handle success if needed
            if (data) {
                setActiveTab("deep-scan-result");
                setDeepScanData(data);
            }
        },
        onError: (error) => {
            console.error("Error during loading:", error);
        }
    });

    const hasDeepScanData = Object.keys(deepScanData).length > 0;
    const isDisabled = isPending || isCheckingDeepScan;

    const buttonIcon = (isPending || isCheckingDeepScan) ? (
        <Spinner size="tiny" />
    ) : hasDeepScanData ? (
        <DocumentBulletListRegular />
    ) : (
        <SearchShieldFilled />
    );

    return (
        <Button
            className={rootUseStyles().buttonInfoOutline}
            disabled={isDisabled}
            icon={buttonIcon}
            onClick={() => {
                if (hasDeepScanData) {
                    setActiveTab("deep-scan-result");
                    return;
                } else {
                    mutate(insightData?.ioc_finder_result?.results);
                }
            }}
        >
            {isCheckingDeepScan ? "Checking..." : hasDeepScanData ? "View Scan Results" : "Run a deep scan"}
        </Button>
    );
}